import { AdminUserReference } from './admin-user';

export interface WorkStatus {
    previous: string;
    status: WorkStatusType;
    admin: AdminUserReference;
    lastModified: string;
}

export enum WorkStatusType {
    Free = 'Free',
    InProgress = 'InProgress',
    UnderDuty = 'UnderDuty',
    Closed = 'Closed',
}
